type SpTextAlign = 'Left' | 'Right' | 'Center' | 'Justify';

const mapSpToBs: Record<SpTextAlign, string> = {
  Left: 'start',
  Right: 'end',
  Center: 'center',
  Justify: 'start', // BS5 no longer has text-justify
};

export function getTextAlignClassName(textAlign?: SpTextAlign): string | undefined {
  return textAlign ? `text-${mapSpToBs[textAlign]}` : undefined;
}
